import { Field, Float, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { StripePayment } from './StripePayment'
import { PaymentRefund } from './PaymentRefund'
import { BaseEntity } from '../base/BaseEntity'
import type { PaymentStatusEnum } from './PaymentStatusEnum'

@ObjectType()
@InputType('PaymentInput')
export class Payment extends BaseEntity {
  @Field(() => Date)
  @Prop({ type: Date })
  date: Date

  @Field(() => String)
  @Prop({ type: String })
  method: string

  @Field(() => String)
  @Prop({ type: String })
  declare status: PaymentStatusEnum

  /**
   * This is the StripePaymentMeta itself
   */
  @Field(() => StripePayment)
  @Prop({ type: StripePayment })
  stripeInfo: StripePayment

  @Field(() => Float)
  @Prop({ type: Number })
  merchantFee: number

  @Field(() => Float)
  @Prop({ type: Number })
  gross: number

  @Field(() => Float)
  @Prop({ type: Number })
  net: number

  @Field(() => [PaymentRefund])
  @Prop({ type: [PaymentRefund] })
  refunds: PaymentRefund[]

  @Field(() => String)
  @Prop({ type: String })
  relatedOrderId: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  checkNumber?: string

  @Field(() => Date, { nullable: true })
  @Prop({ type: Date })
  checkDate?: Date
}
